import { useEffect, useState } from 'react'
import { Onboard as View } from 'ui-components'
import { useIsWorkspaceMember } from '~map-preview/hooks/useIsWorkspaceMember'

export function Onboard() {
  const client = useIsClient()
  const isWorkspaceMember = useIsWorkspaceMember()

  const [open, setOpen] = useState(
    typeof window !== 'undefined' &&
      localStorage.getItem('mapstackTourComplete') !== 'true'
  )

  const handleClose = () => {
    setOpen(false)
  }

  const handleDone = () => {
    localStorage.setItem('mapstackTourComplete', 'true')
  }

  if (!client) return null

  return (
    <View
      open={open}
      stepDisplay
      closeButton
      onClose={handleClose}
      onDone={handleDone}
      steps={[
        {
          hidden: !isWorkspaceMember,
          target: '#MapToolbar',
          heading: 'Make your data stand out',
          content: (
            <>
              Choose how your map looks with different styles—use{' '}
              <b>category maps</b>, <b>aggregate maps</b>, or other custom
              options to highlight key insights.
            </>
          ),
          nextButton: true
        },
        {
          hidden: !isWorkspaceMember,
          target: '#MapFilter',
          heading: 'Zero in on what matters',
          content:
            'Use filters to focus on specific locations, trends, or customer segments in your data.',
          backButton: true,
          nextButton: true
        },
        {
          hidden: !isWorkspaceMember,
          target: '#MapSettings',
          heading: 'Fine-tune how your map works',
          content: (
            <>
              Control how your map is displayed by adjusting its{' '}
              <b>name, default view, and how data is presented.</b>
            </>
          ),
          backButton: true,
          nextButton: true
        },
        {
          hidden: !isWorkspaceMember,
          target: '#MapShare',
          heading: 'Work together and share your insights',
          content: (
            <>
              Invite teammates to <b>view or edit</b>, then share your map as a{' '}
              <b>link, embed, or infographic</b>—whatever fits your audience
              best.
            </>
          ),
          backButton: true,
          nextButton: true
        }
      ]}
    />
  )
}

const useIsClient = () => {
  const [isClient, setIsClient] = useState(false)
  useEffect(() => {
    setIsClient(true)
  }, [])
  return isClient
}
